export default "__VITE_ASSET__BCzQFITh__"